// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#agreement-dialog .el-dialog__body {\n  height: 400px;\n  overflow-y: auto;\n}\n#agreement-dialog .el-dialog__body pre {\n    white-space: break-spaces;\n}\n.basicInfoForm .el-checkbox__label {\n  width: 120px;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  margin-bottom: -6px;\n}\n", ""]);
// Exports
module.exports = exports;
